// 'use strict';

/*
 * Zero pad
 */
export const zeroPad = (num, length) => {
  const n = Math.abs(num);
  const zeros = Math.max(0, length - Math.floor(n).toString().length);
  let zeroString = Math.pow(10, zeros)
    .toString()
    .substr(1);
  if (num < 0) {
    zeroString = '-' + zeroString;
  }
  return zeroString + n;
};

/*
=================================================================================================
  EASING // t = time, b = start value, c = end value, d = duration
=================================================================================================
*/

export const easeInQuad = (t, b, c, d) => {
  return c * (t /= d) * t + b;
};

export const easeOutQuad = (t, b, c, d) => {
  return -c * (t /= d) * (t - 2) + b;
};

export const shuffle = (arra1) => {
  let ctr = arra1.length;
  let temp;
  let index;

  // While there are elements in the array
  while (ctr > 0) {
    // Pick a random index
    index = Math.floor(Math.random() * ctr);
    // Decrease ctr by 1
    ctr--;
    // And swap the last element with it
    temp = arra1[ctr];
    arra1[ctr] = arra1[index];
    arra1[index] = temp;
  }
  return arra1;
};

export const isObjEmpty = (obj) => {
  for (const prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }

  return JSON.stringify(obj) === JSON.stringify({});
};

export const processCaptions = (game, cptData, audioName, suffix = '') => {
  const vosData = game.cache.getJSON(audioName);

  for (const key in vosData.spritemap) {
    if (vosData.spritemap.hasOwnProperty(key)) {
      const cptItem = cptData[key + suffix];
      if (!cptItem) {
        console.log("can't find: " + (key + suffix));
      } else {
        const vo = vosData.spritemap[key];
        const duration = (vo.end - vo.start) * 1000 + 100;
        let start = 0;
        // const dt = Math.round(duration / cptItem.length);

        // first count number of letters
        let lettersAmount = 0;
        for (let i = 0; i < cptItem.length; i++) {
          lettersAmount += cptItem[i].content.length;
        }

        //
        for (let i = 0; i < cptItem.length; i++) {
          const cpt = cptItem[i];
          cpt.start = start;
          const dt = Math.ceil(duration * (cpt.content.length / lettersAmount)); // set time based on the letter in content
          if (vo) {
            cpt.end = start + dt;
          } else {
            cpt.end = (i + 1) * 1000; // 0;
          }
          start += dt;
        }
      }
    }
  }

  return cptData;
};
